// extracted by mini-css-extract-plugin
export var container = "transport-mode-module--container--40e4c";
export var emptyLeftPart = "transport-mode-module--emptyLeftPart--e7ac5";
export var pictogram = "transport-mode-module--pictogram--5e8ee";
export var transportMethodName = "transport-mode-module--transportMethodName--da007";
export var transportModeElement = "transport-mode-module--transportModeElement--21200";
export var transportModes = "transport-mode-module--transportModes--f1d4b";
export var transportModesContainer = "transport-mode-module--transportModesContainer--6ef31";
export var transportModesTitle = "transport-mode-module--transportModesTitle--a80e2";
export var transportModesWrapper = "transport-mode-module--transportModesWrapper--c0d87";